var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticStyle:{"padding":"10px","display":"flex","justify-content":"center"}},[_c('div',{staticClass:"loader"})]),_c('div',{staticClass:"font-36"},[_vm._v("提交成功")])])
}]

export { render, staticRenderFns }